/* eslint-disable */
export const list = state => state.list;
export const listAll = state => state.listAll;
export const partnerPayment = state => state.partnerPayment;
export const newPayment = state => state.newPayment;
export const updateSubscription = state => state.updateSubscription;
export const newPaymentStatus = state => state.newPaymentStatus;
export const newPaymentError = state => state.newPaymentError;
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersPaymentInitialDate = state => state.filtersPaymentInitialDate;
export const filtersPaymentFinalDate = state => state.filtersPaymentFinalDate;
export const filtersCardBrand = state => state.filtersCardBrand;
export const filtersTerminalNumber = state => state.filtersTerminalNumber;
export const filtersOperation = state => state.filtersOperation;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersStatus = state => state.filtersStatus;
export const currentPage = state => state.currentPage;
export const totalResources = state => state.totalResources;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const loadingData = state => state.loadingData;
export const subtotal = state => state.subtotal;
export const transactedTotal = state => state.transactedTotal;
export const settledTotal = state => state.settledTotal;
export const devicesCount = state => state.devicesCount;
export const filterStatus = state => state.filterStatus;
export const showFilters = state => state.showFilters;
export const filterParams = state => state.filterParams;
export const filtersPartner = state => state.filtersPartner;

export const filter = state => {
  const filters = {
    page: state.currentPage || 1,
    limit: state.limit,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      credit_card_brand: state.filtersCardBrand,
      with_terminal_number: state.filtersTerminalNumber,
      status: state.filtersStatus,
      operation: state.filtersOperation,
      sorted_by: state.filtersOrdination,
      with_partner: state.filtersPartner
    }
  };
  return filters;
};

export const pagination = state => {
  const pageSets = {
    page: state.currentPage,
    rowsPerPage: state.limitOptions,
    totalItems: state.totalResources
  };
  return pageSets;
};
